const getChainLogoPath = (chainName) => {
  const formattedName = chainName.toLowerCase().replace(/\s/g, '_')
  const logoSrc = new URL(`../../images/blockchain_logos/${formattedName}.svg`, import.meta.url)
    .href
  return logoSrc
}

export default getChainLogoPath
